document.addEventListener('DOMContentLoaded', function () {
  // Rotating messages
  document.querySelectorAll('[data-pa-rotator]').forEach(function (rotator) {
    var messages = rotator.querySelectorAll('.pa-message');
    if (messages.length <= 1) return;

    var interval = parseInt(rotator.getAttribute('data-interval') || '3000', 10);
    var current = 0;

    setInterval(function () {
      messages[current].classList.remove('is-active');
      messages[current].classList.add('is-leaving');

      var next = (current + 1) % messages.length;

      setTimeout(function () {
        messages.forEach(function (m) { m.classList.remove('is-leaving'); });
        messages[next].classList.add('is-active');
      }, 500);

      current = next;
    }, interval);
  });

  // Language dropdown toggle
  var toggle = document.getElementById('paLangToggle');
  var dropdown = document.getElementById('paLangDropdown');
  if (toggle && dropdown) {
    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      dropdown.classList.toggle('is-open');
    });
    document.addEventListener('click', function (e) {
      if (!dropdown.contains(e.target) && e.target !== toggle) {
        dropdown.classList.remove('is-open');
      }
    });
  }
});